import React, { Component, Fragment } from "react";
import { findIndex, sortBy } from "lodash";
import { Button, Modal } from "react-bootstrap";
import DesignTool from "../../designtool";
import {
  TEXT_COLOR,
  TEXT_SIZE,
  URL_IMG,
  RING_COLOR_DEFAULT,
  RING_SIZE_DEFAULT,
  EARRINGS_TYPE_ID,
  CHARM_TYPE,
  TEXT_SAVE,
  TEXT_NO,
  RODEO_TYPE,
  IMAGE_HEIGHT_DEFAULT,
  MAX_WIDTH_SP
} from "../../const/";

export default class ModalRingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ringColor: "",
      ringSize: null,
      ringId: 0,
      ringPrice: 0,
      ringColorCode: RING_COLOR_DEFAULT,
      listColor: [],
      listSize: [],
      rings: [],
      isShowModal: false
    };
    this.itemRingSizeMin=1;
    this.itemRingSizeMax=1;
  }

  componentDidMount() {
    let {
      handleUpdateState,
      designInfo,
      tmpDesignInfo,
      isKeepData,
      ringIdActive,
      ringTypeList
    } = this.props;
    let { ringId, ringColor, ringSize, ringPrice, ringColorCode } = designInfo;
    this.handleGetRings();

    if (tmpDesignInfo && tmpDesignInfo.ringId !== 0) {
      // console.log("isKeepData", isKeepData);
      // console.log("tmpDesignInfo", tmpDesignInfo);
      if (isKeepData) {
        this.setState(
          {
            ringColor: tmpDesignInfo.ringColor,
            ringSize: tmpDesignInfo.ringSize,
            ringId: tmpDesignInfo.ringId,
            ringPrice: tmpDesignInfo.ringPrice,
            ringColorCode: tmpDesignInfo.ringColorCode
          },
          () => this.handleSelectRing(tmpDesignInfo.ringId, false)
        );
      } else {
        let indexItem = findIndex(
          ringTypeList,
          item => item.id === ringIdActive
        );

        if (indexItem !== -1) {
          let itemRing = ringTypeList[indexItem].rings[0];

          this.setState({
            ringColorCode: itemRing.colors[0].color_code,
            ringColor: itemRing.colors[0].color_name,
            ringSize: itemRing.sizes[0].size,
            listColor: itemRing.colors,
            ringPrice: itemRing.price,
            listSize: itemRing.sizes,
            ringId: itemRing.id
          });
        }
      }

      return;
    }

    if (
      ringId !== 0 &&
      ringColor !== "" &&
      ringSize !== null &&
      ringPrice !== 0
    ) {
      this.setState(
        {
          ringColor: ringColor,
          ringSize: ringSize,
          ringId: ringId,
          ringPrice: ringPrice,
          ringColorCode: ringColorCode
        },
        () => this.handleSelectRing(ringId, false)
      );
    }
  }

  componentDidUpdate(prevProps) {
    let { ringIdActive, ringTypeList } = this.props;

    // Reset rings state when ringIdActive change
    if (prevProps.ringIdActive !== ringIdActive) {
      this.setState({ rings: [] });
    }

    if (
      prevProps.ringIdActive !== ringIdActive ||
      prevProps.ringTypeList !== ringTypeList
    ) {
      this.handleGetRings();
      this.handleResetState();
    }
  }

  handleResetState() {
    this.setState({
      ringColor: "",
      ringSize: null,
      ringId: 0,
      ringPrice: 0,
      ringColorCode: RING_COLOR_DEFAULT,
      listColor: [],
      listSize: []
    });
  }

  handleGetRings() {
    let { ringIdActive, ringTypeList } = this.props;

    // get rings for ringIdActive
    let activeIndex = findIndex(ringTypeList, function(item) {
      return item.id === ringIdActive;
    });

    if (activeIndex !== -1) {
      this.setState({ rings: ringTypeList[activeIndex].rings });
    }
  }

  handleCheckBtn() {
    let { ringColor, ringSize } = this.state;

    if (ringColor === "" || ringSize === null) {
      return true;
    }

    return false;
  }

  handleSelectRing(ringId, isSelect) {
    let { tmpDesignInfo } = this.props;
    let { rings } = this.state;
    let items = DesignTool.getItems();
    let activeIndex = findIndex(rings, function(item) {
      return item.id === ringId;
    });

    if (activeIndex !== -1) {
      this.setState({
        listColor: rings[activeIndex].colors,
        listSize: rings[activeIndex].sizes,
        ringPrice: rings[activeIndex].price
      });
    }

    if (items.length !== 0) {
      if (isSelect) {
        if (tmpDesignInfo.ringId !== 0) {
          this.setState({ tmpRingId: ringId }, () => {
            this.handleKeepDesignTool();
          });
        } else {
          this.setState({ isShowModal: true, tmpRingId: ringId });
        }
      }

      return;
    }

    if (isSelect) {
      this.setState({
        ringColorCode: rings[activeIndex].colors[0].color_code,
        ringColor: rings[activeIndex].colors[0].color_name,
        ringSize: rings[activeIndex].sizes[0].size,
        ringPrice: rings[activeIndex].price,
        ringId: ringId
      });
    }
  }

  handleResetDesignTool() {
    let { handleUpdateState, ringIdActive, ringTypeList } = this.props;
    let { tmpRingId } = this.state;

    // Reset total price
    handleUpdateState("isResetDesign", true);

    let indexItem = findIndex(ringTypeList, item => item.id === ringIdActive);

    DesignTool.clearItems();

    //- Set default ring select
    if (indexItem !== -1) {
      let indexRing = findIndex(
        ringTypeList[indexItem].rings,
        item => item.id === tmpRingId
      );

      if (indexRing !== -1) {
        let valueMaxMin=DesignTool.getMinMaxSizeFromListItem(ringTypeList[indexItem],ringIdActive);
        let itemRing = ringTypeList[indexItem].rings[0];
        handleUpdateState("designInfo", {
          ringId: itemRing.id,
          ringSize: itemRing.sizes[0].size,
          ringSizeMin: valueMaxMin.ringSizeMin,
          ringSizeMax: valueMaxMin.ringSizeMax,
          ringColor: itemRing.colors[0].color_name,
          ringPrice: itemRing.price,
          ringColorCode: itemRing.colors[0].color_code
        });

        this.setState({
          ringColorCode: itemRing.colors[0].color_code,
          ringColor: itemRing.colors[0].color_name,
          ringPrice: itemRing.sizes[0].price,
          ringSize: itemRing.sizes[0].size,
          ringSizeMin: valueMaxMin.ringSizeMin,
          ringSizeMax: valueMaxMin.ringSizeMax,
          isShowModal: false,
          ringId: tmpRingId,
          tmpRingId: 0
        });

        DesignTool.changeView(ringIdActive, {
          size: itemRing.sizes[0].size,
          sizeMin:valueMaxMin.ringSizeMin,
          sizeMax:valueMaxMin.ringSizeMax,
          color: itemRing.colors[0].color_code
        });

        return;
      }
    }

    this.setState({
      isShowModal: false,
      ringColor: "",
      ringSize: null,
      ringId: tmpRingId,
      tmpRingId: 0
    });

    DesignTool.changeView(ringIdActive, {
      size: RING_SIZE_DEFAULT,
      color: RING_COLOR_DEFAULT
    });
  }

  handleCloseModalConfirm() {
    let { rings, ringId } = this.state;
    let activeIndex = findIndex(rings, function(item) {
      return item.id === ringId;
    });

    // Update list color, list size
    if (activeIndex !== -1) {
      this.setState({
        listColor: rings[activeIndex].colors,
        listSize: rings[activeIndex].sizes,
        ringPrice: rings[activeIndex].price
      });
    }

    this.setState({ isShowModal: false });
  }

  handleKeepDesignTool() {
    let { tmpDesignInfo, designInfo,ringIdActive } = this.props;
    let { rings, tmpRingId } = this.state;
    let activeIndex = findIndex(rings, function(item) {
      return item.id === tmpRingId;
    });
    let items = DesignTool.getItems();
    let ringSize = 0;
    let ringPrice = 0;
    let ringColor = "";
    let ringColorCode = RING_COLOR_DEFAULT;
    let isTmpDesign = tmpDesignInfo.ringSize !== null || false;
    let curentRingSize = isTmpDesign
      ? tmpDesignInfo.ringSize
      : designInfo.ringSize;
    let curentRingColor = isTmpDesign
      ? tmpDesignInfo.ringColor
      : designInfo.ringColor;

    if (activeIndex === -1) {
      return;
    }

    let sizeIndex = findIndex(
      rings[activeIndex].sizes,
      item => item.size === curentRingSize
    );
    let colorIndex = findIndex(
      rings[activeIndex].colors,
      item => item.color_name === curentRingColor
    );

    // Check color
    if (colorIndex !== -1) {
      ringColor = rings[activeIndex].colors[colorIndex].color_name;
      ringColorCode = rings[activeIndex].colors[colorIndex].color_code;
    } else {
      ringColor = rings[activeIndex].colors[0].color_name;
      ringColorCode = rings[activeIndex].colors[0].color_code;
    }

    ringPrice = rings[activeIndex].price;

    // Check ring size
    if (sizeIndex !== -1) {
      ringSize = rings[activeIndex].sizes[sizeIndex].size;
    } else {
      let lengthSize = rings[activeIndex].sizes.length;
      let maxSize = sortBy(rings[activeIndex].sizes, ["size"])[lengthSize - 1];
      let minSize = sortBy(rings[activeIndex].sizes, ["size"])[0];
      let listSize = sortBy(rings[activeIndex].sizes, ["size"]);

      // old size in range of new size list
      if (curentRingSize > minSize.size && curentRingSize < maxSize.size) {
        for (let i = 0; i < lengthSize; i++) {
          if (listSize[i].size > curentRingSize) {
            ringSize = listSize[i].size;
            break;
          }
        }
      }

      // old size < min size of size list
      if (curentRingSize < minSize.size) {
        ringSize = minSize.size;
      }

      // old size > max size of size list
      if (curentRingSize > maxSize.size) {
        ringSize = maxSize.size;
        if(ringIdActive==EARRINGS_TYPE_ID){
          if (this.handleCheckTotalSizeMaterial(items, ringSize)) {
            this.setState({ isShowModal: false });
            return;
          }
        }
        else
        {
          //itemRingSizeMax
          if (this.handleCheckTotalSizeMaterial(items, this.itemRingSizeMax)) {
            this.setState({ isShowModal: false });
            return;
          }
        }

      }
    }

    this.setState({
      ringId: tmpRingId,
      ringSize: ringSize,
      ringColor: ringColor,
      ringPrice: ringPrice,
      ringColorCode: ringColorCode
    });

    this.setState({ isShowModal: false });
  }

  handleSelectOption(name, value) {
    this.setState({ [name]: value });
  }

  handleSelectColor(color) {
    this.handleSelectOption("ringColor", color.color_name);
    this.handleSelectOption("ringColorCode", color.color_code);
  }

  handleChoseRing() {
    let { ringColor, ringSize, ringId, ringPrice, ringColorCode } = this.state;
    let {
      handleCloseAllTabs,
      getWidthBrowser,
      handleUpdateState,
      ringIdActive,
      tmpListItem,
      designInfo
    } = this.props;
    let items = DesignTool.getItems();
    let tmpRingSize = designInfo.ringSize;

    if(ringIdActive==EARRINGS_TYPE_ID){
      if (ringColor !== "" && ringSize !== null) {
        // check total size material > ring size select
        if (this.handleCheckTotalSizeMaterial(items, ringSize)) {
          if (tmpListItem.length > 0) {
            handleUpdateState("isKeepData", true);
            handleUpdateState("tmpDesignInfo", {
              ringId: ringId,
              ringSize: ringSize,
              ringSizeMin: designInfo.ringSizeMin,
              ringSizeMax: designInfo.ringSizeMax,
              ringColor: ringColor,
              ringPrice: ringPrice,
              ringColorCode: ringColorCode
            });
          }
          return;
        }
        handleUpdateState("designInfo", {
          ringId: ringId,
          ringSize: ringSize,
          ringColor: ringColor,
          ringPrice: ringPrice,
          ringColorCode: ringColorCode
        });
        handleUpdateState("isShowModalMaterial", false);
      }
      // Reset tmp design
      handleUpdateState("tmpDesignInfo", {
        ringId: 0,
        ringSize: null,
        ringSizeMin: null,
        ringSizeMax: null,
        ringColor: "",
        ringPrice: 0,
        ringColorCode: RING_COLOR_DEFAULT
      });
      handleUpdateState("tmpListItem", []);
      handleUpdateState("tmpRingIdActive", 0);
      handleUpdateState("isKeepData", false);
      if (MAX_WIDTH_SP > getWidthBrowser()) {
        handleCloseAllTabs();
      }
      DesignTool.changeView(ringIdActive, {
        size: ringSize,
        color: ringColorCode
      });
      // update stone when change ring size and ring color
      if (tmpRingSize > ringSize) {
        this.renderDesignTool(items, "smallSize");
        return;
      }
      if (ringSize > tmpRingSize) {
        this.renderDesignTool(items, "bigSize");
        return;
      }
      this.renderDesignTool(items, "color");
    }
    else
    {
      let tmpRingSizeMin = this.itemRingSizeMin;
      let totalSizeMaterial=0;
      //console.log("handleChoseRing ,....................1");

      items.forEach(item => {
        if (item.productType === RODEO_TYPE) {
          totalSizeMaterial += (item.imageSize * item.size) / item.img.height;
        } else if (item.productType === CHARM_TYPE) {
          totalSizeMaterial += item.hookPos
            ? (item.hookPos.hookW / IMAGE_HEIGHT_DEFAULT) * item.size
            : 0;
        } else {
          totalSizeMaterial += item.size;
        }
      });

      if(totalSizeMaterial>tmpRingSizeMin){
        tmpRingSizeMin=totalSizeMaterial;
      }

      //if(tmpRingSizeMin<tmpRingSize)  tmpRingSizeMin=tmpRingSize;

      if (ringColor !== "" && ringSize !== null) {
      // // check total size material > ring size select
        if (this.handleCheckTotalSizeMaterial(items, this.itemRingSizeMax)) {
          if (tmpListItem.length > 0) {
            handleUpdateState("isKeepData", true);
            handleUpdateState("tmpDesignInfo", {
              ringId: ringId,
              ringSize: tmpRingSizeMin,
              ringSizeMax: this.itemRingSizeMax,
              ringSizeMin:this.itemRingSizeMin,
              ringColor: ringColor,
              ringPrice: ringPrice,
              ringColorCode: ringColorCode
            });
          }

          return;
        }

        handleUpdateState("designInfo", {
          ringId: ringId,
          ringSize: tmpRingSizeMin,
          ringSizeMax: this.itemRingSizeMax,
          ringSizeMin:this.itemRingSizeMin,
          ringColor: ringColor,
          ringPrice: ringPrice,
          ringColorCode: ringColorCode
        });
        handleUpdateState("isShowModalMaterial", false);
      }
    //  if(tmpRingSizeMin<tmpRingSize)  tmpRingSizeMin=tmpRingSize;
      // Reset tmp design
      handleUpdateState("tmpDesignInfo", {
        ringId: 0,
        ringSize: tmpRingSizeMin,
        ringSizeMax: this.itemRingSizeMax,
        ringSizeMin:this.itemRingSizeMin,
        ringColor: "",
        ringPrice: 0,
        ringColorCode: RING_COLOR_DEFAULT
      });
      handleUpdateState("tmpListItem", []);
      handleUpdateState("tmpRingIdActive", 0);
      handleUpdateState("isKeepData", false);

      if (MAX_WIDTH_SP > getWidthBrowser()) {
        handleCloseAllTabs();
      }
      DesignTool.changeView(ringIdActive, {
        size: tmpRingSizeMin,
        sizeMax: this.itemRingSizeMax,
        sizeMin:this.itemRingSizeMin,
        color: ringColorCode
      });


      // update stone when change ring size and ring color
      if (tmpRingSize > tmpRingSizeMin) {
        this.renderDesignTool(items, "smallSize");
        return;
      }

      if (tmpRingSizeMin > tmpRingSize) {
        this.renderDesignTool(items, "bigSize");
        return;
      }

      this.renderDesignTool(items, "color");
    }



  }

  // check total size material > ring size select
  handleCheckTotalSizeMaterial(items, ringSize) {
    let {
      handleUpdateState,
      tmpDesignInfo,
      tmpRingIdActive,
      ringIdActive
    } = this.props;
    let totalSizeMaterial = 0;

    items.forEach(item => {
      if (item.productType === RODEO_TYPE) {
        totalSizeMaterial += (item.imageSize * item.size) / item.img.height;
      } else if (item.productType === CHARM_TYPE) {
        totalSizeMaterial += item.hookPos
          ? (item.hookPos.hookW / IMAGE_HEIGHT_DEFAULT) * item.size
          : 0;
      } else {
        totalSizeMaterial += item.size;
      }
    });

    // Check earring size === 0cm
    if (ringIdActive === EARRINGS_TYPE_ID && ringSize === 0) {
      return false;
    }

    if (items.length > 0 && totalSizeMaterial > ringSize) {
      handleUpdateState("isShowDialogMessage", true);
      handleUpdateState(
        "dialogMessage",
        `現在のデザイン素材のサイズ合計は${(totalSizeMaterial / 10).toFixed(
          2
        )}cmになって、選択したいサイズを越えています。素材を減らして再度変更してください。`
      );

      if (tmpDesignInfo.ringId !== 0 && tmpRingIdActive !== 0) {
        handleUpdateState("designInfo", tmpDesignInfo);
        handleUpdateState("isShowModalMaterial", false);
      }

      return true;
    }

    return false;
  }

  renderDesignTool(items, type) {
    let { ringIdActive, productList } = this.props;

    items.sort(function(a, b) {
      return a.angle - b.angle;
    });

    if (items.length > 0) {
      for (var i = 0; i < items.length; i++) {
        let index = findIndex(
          productList,
          item => item.id === items[i].productID
        );
        let hookPos = null;

        if (index !== -1 && items[i].productType === CHARM_TYPE) {
          hookPos = {
            hookW: productList[index].charm_hanger_width,
            hookX: productList[index].charm_hanger_coord_x,
            hookY: productList[index].charm_hanger_coord_y
          };
        }

        // update url image
        let n = items[i].imageURL.search(/t=/i);
        let urlImage = "";

        if (n !== -1) {
          urlImage =
            items[i].imageURL.slice(0, n + 2) + `${new Date().getTime()}`;
        } else {
          urlImage = items[i].imageURL + `?t=${new Date().getTime()}`;
        }

        if (type === "smallSize") {
          DesignTool.addItemChangeSize(
            ringIdActive,
            items[i].angle,
            items[i].sizeID,
            urlImage,
            items[i].imageSize,
            items[i].size,
            items[i].productID,
            items[i].productType,
            hookPos,
            items
          );
        } else {
          DesignTool.addItem(
            ringIdActive,
            items[i].angle,
            items[i].sizeID,
            urlImage,
            items[i].imageSize,
            items[i].size,
            items[i].productID,
            items[i].productType,
            hookPos
          );
        }
      }
    }
  }

  render() {
    let {
      ringColor,
      ringSize,
      ringId,
      rings,
      listColor,
      listSize,
      isShowModal
    } = this.state;
    let { getWidthBrowser,ringIdActive } = this.props;

    var change_object = (<></>);

    if(ringIdActive!=EARRINGS_TYPE_ID){

      this.itemRingSizeMin=100000;
      this.itemRingSizeMax=1;
      listSize.forEach(item => {
        if(item.max_size>this.itemRingSizeMax) this.itemRingSizeMax=item.max_size;
        if(item.size<this.itemRingSizeMin) this.itemRingSizeMin=item.size;
      });
      if(this.itemRingSizeMin>this.itemRingSizeMax) this.itemRingSizeMin =this.itemRingSizeMax;

      change_object=(<><button
                          className="btn dropdown-toggle disable"
                          id="dropdownColor"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          disabled={ false}
                        >
                        {ringSize === null ? TEXT_SIZE : (this.itemRingSizeMin / 10).toFixed(2)+"cm-"+(this.itemRingSizeMax / 10).toFixed(2) }{"cm"}

                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownColor">
                        {
                          <li
                            key={0}
                            onClick={() =>
                              this.handleSelectOption("ringSize", this.itemRingSizeMin)
                            }
                            className={`${ "font-weight-bold" }`}
                          >
                            {(this.itemRingSizeMin / 10).toFixed(2)}{" cm"}-{(this.itemRingSizeMax / 10).toFixed(2)}{" cm"}
                          </li>}
                      </ul></>);
    }
    else
    {

      change_object=(<>
                  <button
                    className="btn dropdown-toggle"
                    id="dropdownColor"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    disabled={ringId === 0 ? true : false}
                  >
                    {ringSize === null ? TEXT_SIZE : (ringSize / 10).toFixed(2)}{" "}
                    cm
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownColor">
                    {
                    sortBy(listSize, ["size"]).map((sizeItem, sizeIndex) => (
                      <li
                        key={sizeIndex}
                        onClick={() =>
                          this.handleSelectOption("ringSize", sizeItem.size)
                        }
                        className={`${
                          ringSize === sizeItem.size ? "font-weight-bold" : ""
                        }`}
                      >
                        {(sizeItem.size / 10).toFixed(2)} cm
                      </li>
                    ))}
                  </ul></>);
    }


    return (
      <Fragment>
        <div
          className={`${getWidthBrowser() < MAX_WIDTH_SP ? "modal_sp" : ""}`}
        >
          <div className="tab_content tab_rings tab_rings_ct">
            <div className="tab_content_wrap scroll_bar_style">
              <ul>
                {rings.map((ring, index) => (
                  <li
                    key={index}
                    onClick={() => this.handleSelectRing(ring.id, true)}
                  >
                    <div className="tab_content_item">
                      <div
                        className={`tab_content_img ${
                          ringId === ring.id ? "active" : ""
                        }`}
                      >
                        <img src={`${URL_IMG + ring.image}`} alt="" />
                      </div>
                      <div className="tab_content_info">
                        <h3 className="tab_content_name" title={ring.name}>
                          {ring.name}
                        </h3>
                        <p>{ring.description}</p>
                        <span className="tab_content_price">{`${ring.price}円`}</span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="tab_action">
            <div className="select_wrap">
              <div className="tab_select">
                <span>カラー</span>
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle"
                    id="dropdownColor"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    disabled={ringId === 0 ? true : false}
                  >
                    {ringColor === "" ? TEXT_COLOR : ringColor}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownColor">
                    {listColor.map((colorItem, colorIndex) => (
                      <li
                        key={colorIndex}
                        onClick={() => this.handleSelectColor(colorItem)}
                        className={`${
                          ringColor === colorItem.color_name
                            ? "font-weight-bold"
                            : ""
                        }`}
                      >
                        {colorItem.color_name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="tab_select tab_select_new">
                <span>サイズ</span>
                <div className="dropdown">

                  {change_object}
                </div>
              </div>
            </div>
            <button
              className={`tab_action_btn ${
                this.handleCheckBtn() ? "disabled" : ""
              }`}
              onClick={() => this.handleChoseRing()}
            >
              この素材を使う
            </button>
          </div>
        </div>

        {/* Modal confirm change ring type */}
        <Modal
          show={isShowModal}
          onHide={() => this.handleCloseModalConfirm()}
          dialogClassName="dialog_custom modal_custom"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <button
              className="modal_close"
              onClick={() => this.handleCloseModalConfirm()}
            >
              <img src="/img/icon_close_new.png" alt="" />
            </button>
            <span>このデザインを使用し続けますか？</span>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => this.handleResetDesignTool()}
            >
              {TEXT_NO}
            </Button>
            <Button
              variant="primary"
              onClick={() => this.handleKeepDesignTool()}
            >
              {TEXT_SAVE}
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}
